export const archiveReportAction = {
  changePage: (state, action) => {
    state.page = action.payload;
    state.fetchTableData = true;
  },

  changePageSize: (state, action) => {
    state.pageSize = action.payload;
  },

  changeReportSearch: (state, action) => {
    state.search = action.payload;
  },

  setSearchQuery: (state, action) => {
    state.searchQuery = action.payload;
  },

  toogleArchiveReportTableData: (state, action) => {
    state.fetchTableData = action.payload;
  },

  changeReportFilters: (state, action) => {
    state.tableFilter = action.payload;
  },

  changeReportOrder: (state, action) => {
    const { field, direction } = action.payload;

    state.orderBy = { field, direction };
  },

  loadArchivedReports: (state, action) => {
    state.reports = action.payload;
  },

  setIsArchiveReport: (state, action) => {
    state.isArchiveReport = action.payload;
  },
};
